import { render, staticRenderFns } from "./Familias.view.vue?vue&type=template&id=a1de4b56"
import script from "./Familias.view.vue?vue&type=script&lang=js"
export * from "./Familias.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports